if (!customElements.get('roastiva-product-gallery')) {
  customElements.define('roastiva-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      const track = this.querySelector('.roastiva-safe-product-gallery');
      const slides = [...track.children];
      const controls = this.querySelector('.roastiva-product-gallery__controls');
      if (!controls || slides.length < 2) return;
      const previous = controls.querySelector('[data-gallery-previous]');
      const next = controls.querySelector('[data-gallery-next]');
      const count = controls.querySelector('[data-gallery-count]');
      const index = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
      const update = () => {
        const current = Math.max(0, Math.min(slides.length - 1, index()));
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        count.textContent = `${current + 1} / ${slides.length}`;
      };
      const move = (step) => track.scrollTo({
        left: Math.max(0, Math.min(slides.length - 1, index() + step)) * track.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      controls.hidden = false;
      update();
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}
